export const SET_MODAL = 'SET_MODAL'
export const SET_MODAL_DATA = 'SET_MODAL_DATA'
export const SET_MODAL_COMPONENT = 'SET_MODAL_COMPONENT'
export const RESET_MODAL = 'RESET_MODAL'
export const SET_CONSULTING_ROOMS = 'SET_CONSULTING_ROOMS'